import { IconValue } from "@gettactic/components/src/icons";

/**
 * The request type's `icon` field is a flat string (the client maps it to/from the
 * backend's `{ identifier }` shape), but `IconPicker` works with an `IconValue`
 * ({ set, icon }). These helpers bridge the two. Format: `"<set>:<icon>"`.
 */
export const serializeIconValue = (value?: IconValue): string | null =>
  value ? `${value.set}:${value.icon}` : null;

export const parseIconValue = (
  value?: string | null
): IconValue | undefined => {
  if (!value) {
    return undefined;
  }
  const separator = value.indexOf(":");
  if (separator === -1) {
    return undefined;
  }
  return { set: value.slice(0, separator), icon: value.slice(separator + 1) };
};
